import { useState } from "react";
import { FiFileText, FiDownload, FiChevronUp, FiChevronDown } from "react-icons/fi";

import styles from "./LoanDocuments.module.scss";
import AfterOnboardAPI from "../../../services/AfterOnboardAPI";

export default function LoanDocuments({ data = [] }) {
  const [open, setOpen] = useState(false);

  const afterOnboardAPI = new AfterOnboardAPI();

  const handleDownload = async (doc) => {
    try {
      const response = await afterOnboardAPI.getDocumentPresignedUrlAPI(doc.documentID);

      if (response?.success && response?.data?.presignedUrl) {
        window.open(response.data.presignedUrl, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  if (!data?.length) return null;
  return (
    <div className={styles.wrapper}>
      <div className={styles.header} onClick={() => setOpen(!open)}>
        <span>View Loan Documents</span>

        {open ? <FiChevronUp size={18} /> : <FiChevronDown size={18} />}
      </div>

      {open && (
        <div className={styles.loanDocuments}>
          {data.map((doc) => (
            <div key={doc.documentID} className={styles.documentCard}>
              <div className={styles.leftSection}>
                <div className={styles.iconBox}>
                  <FiFileText />
                </div>

                <div>
                  <h4>{doc.type}</h4>
                  <span>PDF document</span>
                </div>
              </div>

              <button className={styles.downloadBtn} onClick={() => handleDownload(doc)}>
                <FiDownload />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
